export default __webpack_public_path__ + "static/35-c0d951787259a1a8bf518c686bb8dae2.png";